import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  addEvent(Payload) {
    return this.http.post<any>(`${this.baseUrl}/doctor/create-schedule`, Payload)
      .pipe(map(res => {
        return res;
      }));
  }
  editEvent(Payload) {
    return this.http.post<any>(`${this.baseUrl}/doctor/edit-schedule`, Payload)
      .pipe(map(res => {
        return res;
      }));
  }

  createMultiSchedule(Payload) {
    return this.http.post<any>(`${this.baseUrl}/doctor/create-multi-schedule`, Payload)
      .pipe(map(res => {
        return res;
      }));
  }

  addSchedule(Payload) {
    return this.http.post<any>(`${this.baseUrl}/doctor/create-register-schedule`, Payload)
      .pipe(map(res => {
        return res;
      }));
  }

  deleteSchedule(Payload) {
    return this.http.post<any>(`${this.baseUrl}/doctor/delete-schedule`, Payload)
      .pipe(map(res => {
        return res;
      }));
  }

  getDoctorEvents(id) {
    return this.http.get(`${this.baseUrl}/doctor/get-doctor-schedule-list/${id}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ScheduleService.handleError));
  }

  getDoctorSchedules(id,preStart,preEnd) {
    return this.http.get(`${this.baseUrl}/doctor/get-schedule-list/${id}/${preStart}/${preEnd}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ScheduleService.handleError));
  }
}
